module.exports = __webpack_public_path__ + "img/dwdm.13ef990f.png";